import React from "react";
import { useNavigate } from "react-router-dom";
import { SITE, skillCategories } from "../data/siteData";
import Support from "../components/Support";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{ background: "#fff", fontFamily: "Segoe UI, Arial, sans-serif" }}
    >
      {/* Hero — compact, no excessive padding */}
      <div
        style={{
          background: "#282a35",
          color: "#fff",
          padding: "40px 20px",
          borderBottom: "4px solid #009dc4",
        }}
      >
        <div style={{ maxWidth: 780, margin: "0 auto" }}>
          <h1
            style={{
              fontSize: 28,
              fontWeight: 900,
              marginBottom: 10,
              lineHeight: 1.25,
            }}
          >
            Learn Freelancing. Earn Online from Kenya.
          </h1>
          <p
            style={{
              color: "#bbb",
              fontSize: 15,
              marginBottom: 20,
              maxWidth: 560,
              lineHeight: 1.7,
            }}
          >
            A practical, self-paced guide covering every major skill — Writing,
            Tutoring, AI, Design, VA, Web Dev, and more. Built specifically for
            Kenyan freelancers. Start free today.
          </p>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button
              onClick={() => navigate("/auth?mode=register")}
              style={{
                padding: "9px 22px",
                background: "#009dc4",
                border: "none",
                borderRadius: 3,
                color: "#fff",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Start free — Day 1 is free →
            </button>
            <button
              onClick={() => navigate("/auth")}
              style={{
                padding: "9px 22px",
                background: "none",
                border: "1px solid #555",
                borderRadius: 3,
                color: "#ccc",
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              Sign in
            </button>
          </div>
          <p style={{ color: "#666", fontSize: 12, marginTop: 10 }}>
            Full course: {SITE.priceFull} · One-time M-Pesa payment · No
            subscription · No card needed
          </p>
        </div>
      </div>

      {/* Quick stats bar */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          borderBottom: "1px solid #e0e0e0",
          background: "#fafafa",
        }}
      >
        {[
          ["16", "Comprehensive lessons"],
          ["8", "Skill categories"],
          ["Self-paced", "No deadline"],
          ["Lifetime", "Access forever"],
        ].map(([val, label], i) => (
          <div
            key={i}
            style={{
              flex: "1 1 120px",
              padding: "14px 16px",
              textAlign: "center",
              borderRight: i < 3 ? "1px solid #e0e0e0" : "none",
            }}
          >
            <div style={{ fontWeight: 900, color: "#009dc4", fontSize: 20 }}>
              {val}
            </div>
            <div style={{ fontSize: 12, color: "#666", marginTop: 2 }}>
              {label}
            </div>
          </div>
        ))}
      </div>

      {/* Main content — two columns like W3S */}
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "28px 20px" }}>
        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 24 }}
        >
          {/* Left — skills */}
          <div>
            <h2
              style={{
                fontSize: 17,
                fontWeight: 700,
                color: "#282a35",
                paddingBottom: 8,
                borderBottom: "2px solid #009dc4",
                marginBottom: 16,
              }}
            >
              What you will learn
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 1,
                background: "#e0e0e0",
                border: "1px solid #e0e0e0",
              }}
            >
              {skillCategories.map((cat, i) => (
                <div
                  key={i}
                  onClick={() => navigate("/auth?mode=register")}
                  style={{
                    background: "#fff",
                    padding: "14px 16px",
                    cursor: "pointer",
                    transition: "background 0.1s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#e8f8fc")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#fff")
                  }
                >
                  <p
                    style={{
                      fontWeight: 700,
                      fontSize: 13,
                      color: "#282a35",
                      margin: "0 0 6px",
                    }}
                  >
                    {cat.label}
                  </p>
                  {cat.items.slice(0, 3).map((item, j) => (
                    <p
                      key={j}
                      style={{ fontSize: 12, color: "#666", margin: "0 0 2px" }}
                    >
                      · {item}
                    </p>
                  ))}
                  {cat.items.length > 3 && (
                    <p
                      style={{
                        fontSize: 11,
                        color: "#009dc4",
                        margin: "4px 0 0",
                        fontWeight: 600,
                      }}
                    >
                      +{cat.items.length - 3} more
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right — how it works + pricing */}
          <div>
            <h2
              style={{
                fontSize: 17,
                fontWeight: 700,
                color: "#282a35",
                paddingBottom: 8,
                borderBottom: "2px solid #009dc4",
                marginBottom: 16,
              }}
            >
              How it works
            </h2>
            {[
              [
                "1",
                "Create free account",
                "Register with your email — no card needed.",
              ],
              [
                "2",
                "Explore Day 1 free",
                "Read, take the quiz, complete the checklist.",
              ],
              [
                "3",
                "Pay via M-Pesa",
                `${SITE.priceFull} one-time to till ${SITE.till}.`,
              ],
              [
                "4",
                "Enter your code",
                "We send your access code after confirming payment.",
              ],
              ["5", "Learn at your pace", "All 16 lessons unlocked forever."],
            ].map(([step, title, desc]) => (
              <div
                key={step}
                style={{
                  display: "flex",
                  gap: 12,
                  marginBottom: 14,
                  paddingBottom: 14,
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <div
                  style={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    background: "#009dc4",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 12,
                    fontWeight: 800,
                    flexShrink: 0,
                  }}
                >
                  {step}
                </div>
                <div>
                  <p
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: "#282a35",
                      margin: "0 0 2px",
                    }}
                  >
                    {title}
                  </p>
                  <p
                    style={{
                      fontSize: 12,
                      color: "#666",
                      margin: 0,
                      lineHeight: 1.6,
                    }}
                  >
                    {desc}
                  </p>
                </div>
              </div>
            ))}

            <div
              style={{
                background: "#282a35",
                color: "#fff",
                borderRadius: 4,
                padding: "16px",
                marginTop: 8,
              }}
            >
              <p
                style={{
                  fontSize: 11,
                  color: "#aaa",
                  margin: "0 0 3px",
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                  fontWeight: 700,
                }}
              >
                One-time payment
              </p>
              <p
                style={{
                  fontSize: 26,
                  fontWeight: 900,
                  color: "#009dc4",
                  margin: "0 0 4px",
                }}
              >
                {SITE.priceFull}
              </p>
              <p style={{ fontSize: 12, color: "#aaa", margin: "0 0 14px" }}>
                With referral code: {SITE.priceReferred}
              </p>
              <button
                onClick={() => navigate("/auth?mode=register")}
                style={{
                  width: "100%",
                  padding: "9px 0",
                  background: "#009dc4",
                  border: "none",
                  borderRadius: 3,
                  color: "#fff",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Get started free →
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          borderTop: "1px solid #e0e0e0",
          padding: "16px 20px",
          textAlign: "center",
          background: "#fafafa",
        }}
      >
        <Support />
      </div>
    </div>
  );
}
